import type { Clip } from '../clip.ts';
import { CLIPS as nightmares } from './nightmares.ts';

/** The Long Hunt's wolves (models/caza.ts): the pack's own rig, so the wolves' clips (docs/sendas/barbaro.md, chapter 1). */
const wolf = nightmares.wolf as () => Clip[];
export const CLIPS: Record<string, () => Clip[]> = { howler: wolf, grayWolf: wolf, elderHowler: wolf, ashSeal: wolf };
